import Query from '../../../components/Report';

export const query = ({ fromEnd, fromStart, toStart, toEnd }) =>
    new Query('discover-algo-comparison-entities', { fromEnd, fromStart, toStart, toEnd });
